export default __webpack_public_path__ + "static/media/leo-icon.0a91dea0.png";